const EMAIL_SETUP_KEY = 'instanttranscriber_guest_email_setup';

export function rememberGuestEmailSetup(userId) {
  try { localStorage.setItem(EMAIL_SETUP_KEY, JSON.stringify({ userId, expires: Date.now() + 86400000 })); } catch {}
}

export function hasGuestEmailSetup(userId) {
  try {
    const setup = JSON.parse(localStorage.getItem(EMAIL_SETUP_KEY) || 'null');
    return Boolean(userId && setup?.userId === userId && setup.expires > Date.now());
  } catch { return false; }
}

export function clearGuestEmailSetup() {
  try { localStorage.removeItem(EMAIL_SETUP_KEY); } catch {}
}

export { authErrorType as guestUpgradeErrorType } from './authErrors';
